import { Button } from '@calendly/ui/components/button'
import { Link } from '@calendly/ui/components/link'
import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { HtmlParser } from '@calendly/html-parser'
import { buildQuery } from '@calendly/http-tools'
import { MainPanel } from '@calendly/booking-kit'
import { Loader } from '@calendly/ui/components/loader'
import { TitleText } from '@calendly/ui/components/typography'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { useFlag } from '@calendly/feature-check-react'

import Wrapper from 'components/wrapper'
import Container from 'components/layout/container'
import { useProfile } from 'components/use_profile'
import { useI18n } from 'locales'
import { Settings } from 'services/settings'
import _ErrorPageContainer from "page-ErrorPageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/error/page.js?styleId=ErrorPageContainer";
import _StytchErrorPageContainer from "page-StytchErrorPageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/error/page.js?styleId=StytchErrorPageContainer";
import _Body from "page-Body.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/error/page.js?styleId=Body";
import _StytchBody from "page-StytchBody.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/error/page.js?styleId=StytchBody";
import _Line from "page-Line.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/error/page.js?styleId=Line";
import _StytchLine from "page-StytchLine.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/error/page.js?styleId=StytchLine";
import _StytchHeader from "page-StytchHeader.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/error/page.js?styleId=StytchHeader";


const formatErrorMessage = (message) => {
  const capitalized = message.charAt(0).toUpperCase() + message.slice(1)

  return capitalized.slice(-1) === '.' ? capitalized : `${capitalized.trim()}.`
}

const ErrorPageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ErrorPageContainer",
  styles: _ErrorPageContainer
})

const StytchErrorPageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "StytchErrorPageContainer",
  styles: _StytchErrorPageContainer
})

const Body = /*#__PURE__*/styled('div', null, {
  displayName: "Body",
  styles: _Body
})

const StytchBody = /*#__PURE__*/styled('div', null, {
  displayName: "StytchBody",
  styles: _StytchBody
})

const Line = /*#__PURE__*/styled('div', null, {
  displayName: "Line",
  styles: _Line
})

const StytchLine = /*#__PURE__*/styled('div', null, {
  displayName: "StytchLine",
  styles: _StytchLine
})

const ErrorBody = ({ children }) => {
  const isTabletUp = useDeviceType('isTabletUp')

  return (
    <Body className={isTabletUp ? 'isTabletUp' : undefined}>
      {children}
    </Body>
  )
}

const StytchHeader = /*#__PURE__*/styled('h1', null, {
  displayName: "StytchHeader",
  styles: _StytchHeader
})


const Explanation = ({ email, locale, explanation, action, actionUrl }) => {
  const { i18n } = useI18n()
  return (
    <>
      <Line>
        {
          email
            ? i18n.t('errors.booking.logged_in_as', { email, locale })
            : i18n.t('errors.booking.logged_in_as_admin', { locale })
        }
      </Line>
      <Line>
        <strong>{explanation}</strong>
      </Line>
      {action && (
        <Button
          as="a"
          decoration="outline"
          href={actionUrl}
        >
          {action}
        </Button>
      )}
    </>
  )
}

const LoginLink = ({ children }) => (
  <Link
    underline={false}
    href={`/app/login?${buildQuery({ return_to: window.location.pathname })}`}
  >
    {children}
  </Link>
)
const Login = () => {
  const { i18n } = useI18n()
  return HtmlParser(i18n.t('booking.templates.login_for_details'), { LoginLink })
}

const StytchBlockErrorContent = ({ context, error }) => {
  const isTabletUp = useDeviceType('isTabletUp')

  return (
    <StytchErrorPageContainer>
      <StytchHeader>{formatErrorMessage(error)}</StytchHeader>
      <StytchBody className={isTabletUp ? 'isTabletUp' : undefined}>
        {context.explanation}
      </StytchBody>
      <StytchLine>
        {
          context.telemetry_id !== `tid-${Settings.trust_and_safety.stytch_telemetry_missing_error_id}`
            ? context.telemetry_id
            : 'tid-missing'
        }
      </StytchLine>
    </StytchErrorPageContainer>
  )
}

const ErrorPage = ({
  profile: profileFromProps,
  error: { error, explanation, email, action, url, code, context },
  current_user: { locale }
}) => {
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const profile = useProfile(
    ['event_type_deleted', 'event_type_deactivated'].includes(code) ? {} : profileFromProps
  )

  if (profile === undefined) return <Loader />

  return (
    <Wrapper>
      <Container hideBranding={bookingAppRedesign}>
        <MainPanel>
          {
            context?.stytch_block_verdict ? (
              <StytchBlockErrorContent context={context} error={error} />
            ) : (
              <ErrorPageContainer>
                <TitleText level={2} size="medium">{profile?.name}</TitleText>
                <FlexLayout direction="column" gap={24}>
                  <TitleText level={2} as="h1" size="large">{formatErrorMessage(error)}</TitleText>
                  <ErrorBody>
                    {
                      explanation
                        ? <Explanation email={email} locale={locale} explanation={explanation} action={action} actionUrl={url} />
                        : <Login />
                    }
                  </ErrorBody>
                </FlexLayout>
              </ErrorPageContainer>
            )
          }
        </MainPanel>
      </Container>
    </Wrapper>
  )
}

export default ErrorPage
